/* Maison Ronron v13 bis « ultime » : en-tête (préfixe h).
   Scène collante liée au défilement : --hp (0 → 1) pilote l'illustration qui grandit, l'ombre et le reflet de lumière ;
   les trois légendes apparaissent et s'effacent par fenêtres. Le mouvement suit le défilement avec un léger amorti
   et s'arrête dès que la cible est atteinte (aucune boucle continue). */
(function () {
  'use strict';

  function lisse(x) { const t = Math.min(1, Math.max(0, x)); return t * t * (3 - 2 * t); }

  function fenetre(p, a, b, c, d) {
    if (p < b) { const v = b > a ? lisse((p - a) / (b - a)) : 1; return { v, y: (1 - v) * 26 }; }
    if (p <= c) return { v: 1, y: 0 };
    const v = 1 - lisse((p - c) / (d - c));
    return { v, y: -(1 - v) * 26 };
  }

  function legende(el, f) {
    if (!el) return;
    el.style.opacity = f.v.toFixed(3);
    el.style.transform = 'translate3d(0,' + f.y.toFixed(2) + 'px,0)';
    el.style.setProperty('--hv', f.v.toFixed(3));
    el.style.visibility = f.v < 0.01 ? 'hidden' : 'visible';
  }

  function monter(scene) {
    const colle = scene.querySelector('[data-h-colle]');
    const leg1 = scene.querySelector('[data-h-leg="1"]');
    const leg2 = scene.querySelector('[data-h-leg="2"]');
    const leg3 = scene.querySelector('[data-h-leg="3"]');
    const indice = scene.querySelector('[data-h-indice]');

    if (window.MR14 && MR14.reduit) {
      scene.classList.add('h-statique', 'h-arrive');
      return;
    }

    const cibleDe = () => {
      const r = scene.getBoundingClientRect();
      const course = Math.max(1, r.height - window.innerHeight);
      return Math.min(1, Math.max(0, -r.top / course));
    };
    const appliquer = (p) => {
      if (colle) colle.style.setProperty('--hp', p.toFixed(4));
      legende(leg1, fenetre(p, -1, -1, 0.16, 0.26));
      legende(leg2, fenetre(p, 0.30, 0.38, 0.58, 0.66));
      legende(leg3, fenetre(p, 0.72, 0.80, 2, 3));
    };

    let p = cibleDe();
    let raf = 0;
    let defile = false;
    const cacherIndice = () => {
      if (!defile && window.scrollY > 10) {
        defile = true;
        if (indice) indice.classList.add('h-cache');
      }
    };

    // Amorti : on rejoint la position de défilement en quelques images, puis on s'arrête.
    const pas = () => {
      raf = 0;
      cacherIndice();
      const cible = cibleDe();
      const d = cible - p;
      if (Math.abs(d) < 0.0006) p = cible; else p += d * 0.2;
      appliquer(p);
      if (p !== cible) raf = requestAnimationFrame(pas);
    };

    appliquer(p);
    cacherIndice();
    // Défilement regroupé par image (socle) ; l'amorti ne relance qu'une seule boucle à la fois.
    if (window.MR14 && MR14.auDefilement) MR14.auDefilement(() => { if (!raf) pas(); });
    else {
      const relancer = () => { if (!raf) raf = requestAnimationFrame(pas); };
      addEventListener('scroll', relancer, { passive: true });
      addEventListener('resize', relancer, { passive: true });
    }

    // Entrée : deux images plus tard, pour que les transitions partent de l'état caché.
    requestAnimationFrame(() => requestAnimationFrame(() => scene.classList.add('h-arrive')));
  }

  const demarrer = () => document.querySelectorAll('[data-h-scene]').forEach(monter);
  if (window.MR14 && MR14.pret) MR14.pret(demarrer);
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
